<template>
  <div>
    <div class="row text-center">
      <div class="col-sm-12 col-xs-12">
        <h3> {{ title }} </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="text-center">
          <div v-for="(element, index) in this.dashboardElementsDetailsSmall" :key="index" class="col-xs-10 col-xs-offset-1 col-sm-6" :class="calculatePositionOnGrid(index+1)">
            <div 
            >
              <router-link
                role="link"
                :to="element.route"
                @click.native="buttonClick()"
                :disabled="element.isDisabled(buttonClicked, sitecode, firstRegistration)"
              >
            <div class="grid-content">
                <p class="text-center">
                  <img :src="'static/img/dashboard/' + element.image + '.png'" alt="img" />
                </p>
                <br/>
                 <br/>
                <div class="text-center textButton">
                  {{computeCaption(element.buttonText, $store.state.lang.value.toLowerCase())}}
                </div>
              </div>
              </router-link>
              </div>
          </div>
          </div>
        </div>
      </div>
    <br/>
  </div>
</template>

<script>
  import FirstStep from '../../Forms/Wizard/FirstStep.vue'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {gridUtils} from '../../../../../utils/DashboardGrid'
  export default {
    components: { FirstStep },
    mixins: [TranslationsUtils, gridUtils],
    data () {
      return {
        buttonClicked: false,
        sitecode: this.$store.state.sitecode,
        firstRegistration: this.$store.state.firstRegistration,
        errorData: ''
      }
    },
    methods: {
      buttonClick () {
        this.buttonClicked = true
      },
      buttonClickLogOut () {
        this.buttonClicked = true
        localStorage.clear()
      }
    },
    computed: {
      title () {
        return this.$store.state.configs.LAB_NAME
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

// .grid-content-top {
//   margin-top: 10px;
//   border-radius: 10px;
//   min-height: 300px;
// }
button{
  white-space: normal !important;
  word-wrap: break-word;
  margin-bottom: 10px;
  width: 90%;
}

.w-90{
  width: 90%;
  margin: 0 auto;
  margin-bottom: 10px;
  min-height: 90px;
}

.w-90-big-tile{
  width: 90%;
  margin: 0 auto;
  margin-bottom: 10px;
}

.grid-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 25px !important;
  border-radius: 0;
  min-height: 260px;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 6px #0000004C;
  padding: 40px 0 20px;
  transition:0.4s;
  &:hover{
    background: #F5F8FB;
    border:1px solid #8FB3D0;
    .textButton {
      color:#51A7E9;
    }
  }
  img{
    height: 100px;
  }
  .textButton{
    color: #757575;
    font-size: 17px;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    transition: 0.4s;
  }
}

.disabled {
  background-color: lightgrey !important;
}

.disabled button{
  color: #1f1f1f !important;
}

.disabled button:hover{
  color: #1f1f1f !important;
}

.disabled p i {
  color: grey !important;
}

.icon {
  padding-top: 20px;
  font-size: 50px;
}

i {
  margin-top: 15px;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

li {
  padding-left: 10px;
}
.text {
  font-size: 15px;
}
.col-xs-offset-1{
  margin-left: 0;
}
@media screen and (max-width: 1200px) {
  .grid-content {
    margin-top: 30px;
    min-height: 250px;
    max-height: 250px;
  }
  .w-90 {
    min-height: 130px;
  }
}

@media screen and (max-width: 1110px) {
  .grid-content {
    margin-top: 30px;
    min-height: 220px;
    img {
      height: 80px;
    }
  }
  .w-90 {
    min-height: 155px;
  }
}

@media screen and (max-width: 990px) {
  .display-mobile-none {
    display:none
  }
  .grid-content {
    margin-top: 30px;
    min-height: 220px;
    img {
      height: 100px;
    }
  }
  .w-90 {
    min-height: 20px;
  }
}
@media screen and (max-width: 755px) {
  .col-xs-offset-1{
    margin-left: 8%;
  }
}
@media screen and (max-width: 310px) {
  .display-mobile-none {
    display:none
  }
  .grid-content {
    margin-top: 30px;
    min-height: 340px;
  }
  .w-90 {
    min-height: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/SmallDashboard.vue